

















































































































































































































































import Vue from 'vue';
import Component from 'vue-class-component';
import { Resolve } from 'vue-di';
import LayoutModule from '~/store/layout';
import { Title } from '~/decorators/Title';
// import EligibilityModule from '~/store/eligibility';

@Component<Index>({
    layout: 'default',
    methods: {
        navigateToDrugsProgramRequirements() {
            if (this.program === 'tremfya') {
                const routeData = this.$router.resolve({ path: '/program-requirements', query: { program: 'tremfya' } });
                window.open(routeData.href, '_blank');
            } else if (this.program === 'stelara') {
                const routeData = this.$router.resolve({ path: '/program-requirements', query: { program: 'stelara' } });
                window.open(routeData.href, '_blank');
            }
        },
    },
})
@Title(process.env.NAME!)
export default class Index extends Vue {
    @Resolve
    public layout!: LayoutModule;

    program = this.layout.program;

    public get brkPoints() {
        return {
            'brk-xs': this.$vuetify.breakpoint.xs,
            'brk-xs-only': this.$vuetify.breakpoint.xsOnly,
            'brk-sm': this.$vuetify.breakpoint.sm,
            'brk-sm-only': this.$vuetify.breakpoint.smOnly,
            'brk-sm-and-down': this.$vuetify.breakpoint.smAndDown,
            'brk-sm-and-up': this.$vuetify.breakpoint.smAndUp,
            'brk-md': this.$vuetify.breakpoint.md,
            'brk-md-only': this.$vuetify.breakpoint.mdOnly,
            'brk-md-and-down': this.$vuetify.breakpoint.mdAndDown,
            'brk-md-and-up': this.$vuetify.breakpoint.mdAndUp,
            'brk-lg': this.$vuetify.breakpoint.lg,
            'brk-lg-only': this.$vuetify.breakpoint.lgOnly,
            'brk-lg-and-down': this.$vuetify.breakpoint.lgAndDown,
            'brk-lg-and-up': this.$vuetify.breakpoint.lgAndUp,
            'brk-xl': this.$vuetify.breakpoint.xl,
            'brk-xl-only': this.$vuetify.breakpoint.xlOnly,
        };
    }
}
